import { useTranslation } from 'react-i18next';
import Header from '../components/Header';
import Footer from '../components/Footer';
import useNoIndex from '../hooks/useNoIndex';
import '../styles/fonts.css';

function EmBreve() {
  const { t } = useTranslation();
  useNoIndex();
  return (
    <div style={{ minHeight: '100vh', background: '#1b1f23', display: 'flex', flexDirection: 'column' }}>
      <Header />
      <main style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '12px', padding: '60px 16px' }}>
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#585f68" strokeWidth="1.5">
          <circle cx="12" cy="12" r="10"/>
          <path d="M12 6v6l4 2"/>
        </svg>
        <h2 style={{ color: '#c9d1d9', fontSize: '20px', fontWeight: 700, margin: 0 }}>{t('common.comingSoon')}</h2>
        <p style={{ color: '#8b949e', fontSize: '14px', margin: 0 }}>{t('common.underConstruction')}</p>
      </main>
      <Footer />
    </div>
  );
}

export default EmBreve;
